import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-india-ta-dashboard',
  templateUrl: './india-ta-dashboard.component.html',
  styleUrls: ['./india-ta-dashboard.component.scss']
})
export class IndiaTaDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
